import { motion } from "motion/react"

const BAR_COUNT = 7
const BAR_DURATIONS = [0.7, 0.95, 0.55, 1.1, 0.8, 0.6, 0.9]
const BAR_DELAYS = [0, 0.15, 0.3, 0.05, 0.22, 0.12, 0.27]
const BAR_PEAKS = [0.9, 0.6, 1, 0.45, 0.85, 0.55, 0.75]

export function Waveform() {
  return (
    <div className="flex h-4 items-center gap-0.75" aria-hidden="true">
      {Array.from({ length: BAR_COUNT }).map((_, i) => (
        <motion.span
          // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length decorative bars
          key={i}
          className="block w-0.5 origin-center rounded-full bg-brand/85"
          initial={{ scaleY: 0.25 }}
          animate={{
            scaleY: [0.25, BAR_PEAKS[i], 0.3, BAR_PEAKS[i] * 0.7, 0.25],
          }}
          transition={{
            duration: BAR_DURATIONS[i],
            delay: BAR_DELAYS[i],
            repeat: Number.POSITIVE_INFINITY,
            ease: "easeInOut",
          }}
          style={{ height: "100%" }}
        />
      ))}
    </div>
  )
}
